import * as React from 'react';
import invariant from 'invariant';

import BoxBody from 'components/BoxBody';
import Button from 'components/ButtonDeprecated';
import Buttons from 'components/Buttons';
import Checkbox from 'components/Checkbox';
import Copy from 'components/Copy';
import Dialog from 'components/Dialog';
import Field from 'components/Field';
import Label from 'components/Label';
import Link from 'components/Link';
import LinkConstants from 'constants/LinkConstants';
import ModalTrigger from 'components/ModalTrigger';
import OrganizationActions from 'actions/OrganizationActions';
import Textarea from 'components/Textarea';
import ToastActions from 'actions/ToastActions';
import type { RemoveUsersMessage } from 'actions/OrganizationActions';

type Props = {
  reportModal?: Function;
  userName?: string;
  userIds: Backbone$Id[];
  orgName: string;
  orgId: Backbone$Id;
  onRequestHide?: Function;
  onRemoved?: Function;
};

// @ts-expect-error ts-migrate(2304) FIXME: Cannot find name '$FlowFixMeState'.
class RemoveFromOrgModal extends React.Component<Props, $FlowFixMeState> {
  state = {
    isSubmitting: false,
    selectedBan: false,
    reason: '',
  };

  closeModal = () => {
    const { onRequestHide } = this.props;
    invariant(onRequestHide, 'modal must have onRequestHide');
    // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    onRequestHide();
  };

  onNoteChange = (event: any) => {
    this.setState({ reason: event.target.value });
  };

  removeOrBanUsers = async () => {
    const { orgName, orgId, userIds, onRemoved } = this.props;

    const isBan = this.state.selectedBan;

    const removeAction = isBan
      ? OrganizationActions.batchBanFromOrg
      : OrganizationActions.batchRemoveFromOrg;

    try {
      const data: RemoveUsersMessage = await removeAction(orgId, userIds, this.state.reason);
      if (data.message[0] === 'S') {
        // this is a hacky way to check if the message starts with "S" for "Some users could not be removed"
        ToastActions.showErrorToast(`${data.message}`);
      } else {
        ToastActions.showSuccessToast(`${data.message}`);
      }
      this.setState({ isSubmitting: false });
      if (onRemoved) {
        onRemoved();
      }
      this.closeModal();
    } catch (error) {
      this.setState({ isSubmitting: false });
      ToastActions.showErrorToast(`Something went wrong! No one was removed from ${orgName}.`);

      this.setState({ isSubmitting: true });
    }
  };

  renderBody = () => {
    const { userName, reportModal, userIds } = this.props;
    const { reason, isSubmitting } = this.state;

    let reportLink = 'report that person to Remind';
    if (reportModal) {
      // @ts-expect-error ts-migrate(2322) FIXME: Type 'Element' is not assignable to type 'string'.
      reportLink = (
        <ModalTrigger modal={reportModal(userName, userIds[0])}>
          <Link onClick={this.closeModal}>{reportLink}</Link>
        </ModalTrigger>
      );
    }

    return (
      <BoxBody divided>
        <Copy color="graphite">
          <div>
            <p>
              If {userName ? `${userName} is` : 'they are'} violating our{' '}
              <Link href={LinkConstants.COMMUNITY_GUIDELINES} target="_blank">
                Community Guidelines
              </Link>
              , please {reportLink}.
            </p>
            When you remove {userName || 'them'},
            <ul>
              <li>
                You will no longer have access to their message history. Please{' '}
                <Link target="_blank" href={LinkConstants.CONVERSATION_MESSAGE_HISTORY}>
                  send their message history to yourself{' '}
                </Link>
                before completing this action.
              </li>
              <li>They will no longer appear in the school roster.</li>
              <li>They will be removed from classes linked to the school.</li>
              <li>Classes they own will be unlinked from the school.</li>
            </ul>
            <p>
              {userName || 'They'} will be notified by email, and you can add a custom message
              below.
            </p>
          </div>
        </Copy>
        <Field>
          <Label>Type your message</Label>
          <Textarea
            value={reason}
            placeholder="Type your message here"
            onChange={this.onNoteChange}
          />
        </Field>
        <Field>
          <Checkbox
            data-test="ban-checkbox"
            onChange={() => this.setState({ selectedBan: !this.state.selectedBan })}
          >
            <Copy color="graphite">
              Also ban {userName || 'these people'} from joining {this.props.orgName} again
            </Copy>
          </Checkbox>
        </Field>
        <Buttons axis="y">
          <Button
            data-test="confirm-button"
            color="mascot"
            level="primary"
            full
            disabled={isSubmitting}
            onClick={this.removeOrBanUsers}
          >
            Remove from school
          </Button>
          <Button color="mascot" level="text" onClick={this.closeModal}>
            Cancel
          </Button>
        </Buttons>
      </BoxBody>
    );
  };

  render() {
    const { userIds, orgName, userName } = this.props;
    let title;
    if (userName) {
      title = (
        <span>
          Remove {userName} from {orgName}?
        </span>
      );
    } else {
      title = (
        <span>
          Remove {userIds.length === 1 ? '1 person' : `${userIds.length} people`} from {orgName}
        </span>
      );
    }

    return (
      <Dialog
        eventScreenName="RemoveFromOrgModal"
        size="small"
        // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
        onRequestHide={this.props.onRequestHide}
        title={title}
      >
        {this.renderBody()}
      </Dialog>
    );
  }
}

export default RemoveFromOrgModal;
